module.exports = __webpack_public_path__ + "static/man-woman-tablet.0246d3c1.jpg";